export default __webpack_public_path__ + "static/media/onboarding-app-platform-mobile.33495bf9.png";